const e = {
  schema: {
    schema: {
      method: "get",
      url: "/schema.json"
    }
  }
};
export {
  e as schemaJsonService
};
